import { Injectable } from "@angular/core";
import { Constants } from "../../common";
import { map, Observable } from "rxjs";
import { PaginationFilter } from "src/app/shared/interfaces";
import { NotificationsModel } from "../model/notifications-model";
import { BaseAPI } from "./base-api";
import { Mapper } from "../mapper";

@Injectable({
    providedIn: 'root'
})
export class NotificationsApi {

    constructor(protected baseApi: BaseAPI, protected mapper: Mapper) {}

    getLatestNotifications(filter: PaginationFilter): Observable<NotificationsModel[]> {
        return this.baseApi
        .get(Constants.GET_LATEST_NOTIFICATIONS_API_URL+`?${this.baseApi.setQueryParams(filter)}`)
        .pipe(map(res => this.mapper.fromListJson(NotificationsModel, res.latestNotifications)));
    }

    getUnseenNotificationsCount(): Observable<number> {
        return this.baseApi
        .get(Constants.GET_UNSEEN_NOTIFICATIONS_COUNT_API_URL)
        .pipe(map(res => res.count));
    }

    markNotificationAsRead(notificationId: string): Observable<string> {
        return this.baseApi
        .post(Constants.MARK_NOTIFICATION_AS_READ_API_URL, {notificationId})
        .pipe(map(res => res.message));
    }

    updateAdminNotificationToken(notificationToken: string): Observable<string> {
        return this.baseApi
        .post(Constants.UPDATE_NOTIFICATION_TOKEN_API_URL, {notificationToken})
        .pipe(map(res => res.message))
    }
}